const PROFESSIONAL_ROUTES = Object.freeze({
	root: {
		name: 'ProfessionalRoot',
		path: '/professional',
		meta: {
			layout: 'Default',
			requiresAuth: true,
			allowedRoles: ['Professional'],
		},
		redirect: {
			name: 'ProfessionalDashboard',
		},
		component: () => import('@/presentation/modules/professional/views/RootView.vue'),
	},
	dashboard: {
		name: 'ProfessionalDashboard',
		path: '',
		meta: {
			layout: 'Default',
			requiresAuth: true,
			allowedRoles: ['Professional'],
		},
		component: () => import('@/presentation/modules/professional/views/ProfessionalDashboardView.vue'),
	},
	bookings: {
		name: 'ProfessionalBookings',
		path: 'bookings',
		meta: {
			layout: 'Default',
			requiresAuth: true,
			allowedRoles: ['Professional'],
		},
		component: () => import('@/presentation/modules/professional/views/ProfessionalBookingsView.vue'),
	},
	calendar: {
		name: 'ProfessionalCalendar',
		path: 'calendar',
		meta: {
			layout: 'Default',
			requiresAuth: true,
			allowedRoles: ['Professional'],
		},
		component: () => import('@/presentation/modules/professional/views/ProfessionalCalendarView.vue'),
	},
	services: {
		name: 'ProfessionalServices',
		path: 'services',
		meta: {
			layout: 'Default',
			requiresAuth: true,
			allowedRoles: ['Professional'],
		},
		component: () => import('@/presentation/modules/professional/views/ProfessionalServicesView.vue'),
	},
	workplaces: {
		name: 'ProfessionalWorkplaces',
		path: 'workplaces',
		meta: {
			layout: 'Default',
			requiresAuth: true,
			allowedRoles: ['Professional'],
		},
		component: () => import('@/presentation/modules/professional/views/ProfessionalWorkplacesView.vue'),
	},
	publicProfile: {
		name: 'PublicProfessionalProfile',
		path: '/professionals/:slug',
		meta: {
			layout: 'Simple',
		},
		component: () => import('@/presentation/modules/professional/views/PublicProfessionalProfileView.vue'),
	},
	profile: {
		name: 'ProfessionalProfile',
		path: 'profile',
		meta: {
			layout: 'Default',
			requiresAuth: true,
			allowedRoles: ['Professional'],
		},
		component: () => import('@/presentation/modules/professional/views/ProfessionalProfileView.vue'),
	},
});

export default PROFESSIONAL_ROUTES;
